import React from 'react';
import { SimpleSection } from '../simpleSection';
import check from '../../icons/icon_check.svg';
import { Title } from '../title';
import { SimpleBadge } from '../simpleBadge';
import './resultado.css';
import { Service } from '../../service';
import { AppData } from '../../types/types';

interface ResultadoProps {
    isMobile?: boolean;
    data: AppData;
}

export const Resultado: React.FC<ResultadoProps> = ({ isMobile = false, data }) => {
    const activities = data.activities ?? [];

    const days = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
    const unidade = Service.getLocations()!.filter((unidade) => unidade.api === data.unidade)[0];

    return (
        <>
            <div className="container">
                <div className="row d-flex resultado">
                    {!isMobile && (
                        <div className="col-xs-24 col-sm-12 p-3">
                            <div className="resultado-image p-2">
                                <img
                                    src="http://posto011.com.br/wp-content/uploads/2024/04/bg_agendamento.png"
                                    className="img-responsive img-fluid"
                                    alt="agendamento"
                                />
                            </div>
                        </div>
                    )}
                    <div className="col-xs-24 col-sm-12 p-2">
                        <SimpleSection>
                            <img
                                src={check}
                                alt="icone-confirmacao"
                            />
                            <Title text={'Locação confirmada!'} />
                            <p>Abaixo os detalhes do seu agendamento</p>
                            <SimpleBadge
                                title="Aluno"
                                text={data.nome + ' - ' + data.email}
                            />
                            <br />
                            {activities.map((activity, idx) => {
                                const dateArray = activity.startString!.split(' ');
                                const date = new Date(activity.activityDate);
                                return (
                                    <SimpleBadge
                                        key={activity.idConfiguration ?? idx}
                                        title="Data e horário"
                                        text={
                                            date.getDate() +
                                            '/' +
                                            (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) +
                                            ' - ' +
                                            days[date.getDay()] +
                                            ' - ' +
                                            dateArray[0]
                                        }
                                    />
                                );
                            })}
                            <SimpleBadge
                                title="Unidade"
                                text={
                                    <>
                                        {(data.classificao === 'Interior' ? 'Interior de São Paulo' : data.classificacao) + ' - ' + unidade?.nome} -{' '}
                                        <a
                                            href={unidade?.mapa}
                                            style={{ color: '#00733f' }}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <u>{unidade?.endereco}</u>
                                        </a>
                                    </>
                                }
                            />
                            <br />
                            <SimpleBadge
                                title={
                                    <>
                                        <a
                                            style={{ color: '#00733f' }}
                                            target="_blank"
                                            rel="noreferrer"
                                            href="https://api.whatsapp.com/send/?phone=5511971029718&text=Ol%C3%A1,%20vim%20pelo%20seu%20Site.%20Quero%20saber%20mais%20sobre%20as%20aulas%20no%20Posto%20011!"
                                        >
                                            <i className="fab fa-whatsapp"></i> Dúvidas?! Fale com a gente!
                                        </a>
                                    </>
                                }
                            />
                            <br />
                            <div className={'resultado-obs'}>
                                Caso você tenha um imprevisto e não consiga comparecer ao agendamento realizado aqui, é só entrar em contato com o
                                nosso time de atendimento online que faremos a remarcação dessa locação para você.
                            </div>
                        </SimpleSection>
                    </div>
                </div>
            </div>
        </>
    );
};
